import { getExtension } from "../../../../ui library/helpers/functions";
import HNSColors from "../../../../ui library/HNSColors";

const ViewDocument = ({ documentUrl }) => {
  const fileExtension = getExtension(documentUrl);

  return (
    <div
      className="flex flex-col items-center justify-center w-full h-full p-4"
      style={{
        backgroundColor: HNSColors.tertiary[900],
      }}
    >
      {documentUrl && fileExtension ? (
        <object
          data={documentUrl}
          aria-label={documentUrl}
          style={{
            width: "100%",
            height: "100%",
            display: "block",
            borderRadius: "1rem",
          }}
        />
      ) : (
        <p className="w-full text-xl font-bold text-center">No File Preview Available</p>
      )}
    </div>
  );
};

export default ViewDocument;
